import { render, staticRenderFns } from "./ElementsBlock.vue?vue&type=template&id=10bda0af&"
import script from "./ElementsBlock.vue?vue&type=script&lang=js&"
export * from "./ElementsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports